import type { SigninRequest, User } from 'oidc-client';
import { createContext, use } from 'react';

export type AuthContextProps = {
  signinRedirectCallback: () => Promise<User>;
  signinRedirect: (idp?: string, loginQueryParams?: unknown) => Promise<void>;
  createSigninRequest: () => Promise<SigninRequest>;
  logout: () => Promise<void>;
  signoutRedirectCallback: () => Promise<void>;
  signinSilent: () => Promise<User>;
};

export const AuthContext = createContext<AuthContextProps>(undefined!);

export const AuthConsumer = AuthContext.Consumer;

export const useAuth = () => {
  const context = use(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
